/**
 * The Azerty Labs dot visual, mirroring its site's hero: 520 dots on a
 * jittered spherical shell that breathe and part around the pointer.
 */
import React from "react";
import { drawDotField } from "./dotField";
import { dotMotion, randomOnShell } from "./dotGeometry";
import useDotCanvas from "./useDotCanvas";

const DOT_COUNT = 520;

/** The sphere's dots, on a shell between radius 0.88 and 1.08. */
export const buildSphereDots = () =>
	Array.from({ length: DOT_COUNT }, () => {
		const [x, y, z] = randomOnShell(0.88, 0.2);
		return { x, y, z, ...dotMotion() };
	});

// Azerty Labs' own orange, not the site accent: this canvas copies their hero.
const SPHERE_LOOK = { color: "#ff4a1c", radiusScale: 0.42, breathAmp: 0.07, pushScale: 0.18 };

/** Draws one sphere frame (see drawDotField). */
export const drawSphereFrame = (ctx, state, t, animate) =>
	drawDotField(ctx, state, t, animate, SPHERE_LOOK);

/**
 * The Azerty Labs sphere canvas; it fills its positioned parent.
 * @param {{ className?: string }} props
 */
const HeroDotSphere = ({ className = "" }) => {
	const canvasRef = useDotCanvas(buildSphereDots, drawSphereFrame, { eager: true });
	return (
		<canvas
			ref={canvasRef}
			className={`block w-full h-full ${className}`.trim()}
			aria-hidden="true"
		/>
	);
};

export default HeroDotSphere;
